module.exports = __webpack_public_path__ + "img/s4-2.3ce3a0ca.jpg";